import { rehydration, store } from './index';
import { batch } from 'react-redux';
import { StoreInterface } from './types';
import { PayloadAction } from '@reduxjs/toolkit';

class ReduxActions {
  public dispatch = (action: PayloadAction): void => {
    store.dispatch(action);
  };

  public getStore = (): StoreInterface => {
    return store.getState();
  };

  public clearReduxStore = (): void => {
    store.dispatch({ type: 'RESET_STORE' });
  };

  public batchActions = (actionArray: PayloadAction[]): void => {
    return batch(() => {
      actionArray.forEach((action) => {
        store.dispatch(action);
      });
    });
  };

  public rehydrated = (): Promise<boolean> => {
    return rehydration();
  };
}

export default new ReduxActions();
